<template>
	<div class="log">
		<div class="queryDiv">
			<div>用户名：<a-input placeholder="请输入手机号或身份号码" v-model="name" /></div>
			<div>时间范围：<a-range-picker @change="onChange" /></div>
			<a-button type="primary" @click="queryClick">查询</a-button>
		</div>
		<div class="greyDiv"></div>
		<div class="tableDiv">
			<p>{{parseInt(type) === 1 ? '日志列表' : '登录日志'}}</p>
			<a-table :columns="parseInt(type) === 1 ? columnsTwo : columns" :data-source="dataInquire" :rowKey="row => row.key">
				<span slot="REMARKS" slot-scope="text, record">{{record.NAME}}{{record.REMARKS ? '-' : ''}}{{record.REMARKS}}</span>
			</a-table>
		</div>
	</div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
export default {
	name: 'Log',
	props: [
		'type'
	],
	data () {
		return {
			name: null,
			startTime: null,
			endTime: null,
			columns: [
				{
					title: '序号',
					dataIndex: 'key',
					key: 'key'
				},
				{
					title: '用户名',
					dataIndex: 'USER_NAME',
					key: 'USER_NAME',
				},
				{
					title: 'IP地址',
					dataIndex: 'IP',
					key: 'IP',
				},
				{
					title: '登录时间',
					key: 'C_TIME',
					dataIndex: 'C_TIME'
				},
				{
					title: '登录设备',
					key: 'DEVICE',
					dataIndex: 'DEVICE'
				},
			],
			columnsTwo: [
				{
					title: '序号',
					dataIndex: 'key',
					key: 'key',
					width: 60
				},
				{
					title: '用户名',
					dataIndex: 'USER_NAME',
					key: 'USER_NAME',
				},
				{
					title: 'IP地址',
					dataIndex: 'IP',
					key: 'IP',
				},
				{
					title: '操作时间',
					key: 'C_TIME',
					dataIndex: 'C_TIME'
				},
				{
					title: '操作描述',
					key: 'REMARKS',
					dataIndex: 'REMARKS',
					scopedSlots: { customRender: 'REMARKS' },
				},
			],
			dataInquire: []
		}
	},
	computed: {
		...mapState([
			'teacherAdmin',
			'logInquires'
		])
	},
	methods: {
		...mapActions([
			'logInquire'
		]),
    onChange(date, dateString) {
      console.log(date, dateString)
			this.startTime = dateString[0]
			this.endTime = dateString[1]
    },
		queryClick () {
			console.log(this.name)
			console.log(this.startTime)
			console.log(this.endTime)
			let moment = require('moment')
			this.dataInquire = this.logInquires.filter(item => this.name ? item.USER_NAME === this.name : true).filter(item => (this.startTime && this.endTime) ? moment(item.C_TIME).isBetween(this.startTime, this.endTime) : true)
		}
  },
	async mounted () {
		let info = {
			school_id: this.teacherAdmin.school_id
		}
		if (parseInt(this.type) !== 1) {
			info.name = '登录'
		}
		await this.logInquire(info)
		this.logInquires.sort((a, b) => b.ID - a.ID)
		for(let [key, value] of this.logInquires.entries()) {
			value.key = (key + 1).toString()
		}
		this.dataInquire = this.logInquires
		console.log(this.dataInquire)
	}
}
</script>

<style scoped>
.log {
	width: 100%;
	display: flex;
	flex-direction: column;
	background-color: #FFFFFF;
}
.log > div {
	padding: 15px 33px;
	box-sizing: border-box;
}
.log .queryDiv, .log .queryDiv > div {
	display: flex;
	align-items: center;
	margin-right: 30px;
}
.log .queryDiv .ant-input {
	width: 200px;
}
.log .queryDiv .ant-calendar-picker {
	width: 300px;
}
.log .greyDiv {
	width: 100%;
	height: 18px;
	background: #FAFAFA;
}
.log .tableDiv p {
	font-size: 18px;
	font-weight: bold;
	margin-bottom: 24px;
}
.log > div.tableDiv {
	padding: 33px;
}
</style>
